(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.InsightsDashboards = factory());
}(this, (function () { 'use strict';

	var widgets$i = [
		{
			id: "39e8c4ac-66ac-442f-890b-8d613daf9d57",
			title: "Internal AWS Organization sub-accounts",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_account with _source!='system-mapper' and master!=true as a\nreturn a.accountId, a.displayName, a.description, a.email, a.mfaEnabled, a.mfaTokenSerial\norder by a.displayName"
					}
				]
			}
		},
		{
			id: "c4b6fc77-f8b2-4bef-8092-f5aafa1a2b52",
			title: "Sandbox AWS Accounts",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_account with _source='system-mapper' as a\nthat has aws_account\nreturn a.accountId, a.displayName, a.orgAccountName, a.email\norder by a.displayName"
					}
				]
			}
		},
		{
			id: "6d442eea-2404-4053-b8b1-ee7ab3e94d8b",
			title: "External Vendor AWS accounts",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_account with _source='system-mapper' as a\nthat !has aws_account\nreturn a.accountId, a.displayName, a.validated"
					}
				]
			}
		},
		{
			id: "85247439-d5cc-4bf8-ac8d-71bb12c64f0e",
			title: "AWS Master Account",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_account with master=true as a\nreturn a.accountId, a.displayName, a.description, a.email, a.mfaEnabled\norder by a.displayName"
					}
				]
			}
		},
		{
			id: "397f5108-a367-4c86-ab14-4d1d1cd01d54",
			title: "AWS Organization Sub-Accounts",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_account with _source!='system-mapper' and master!=true as a\nreturn count(a) as value"
					}
				]
			}
		},
		{
			id: "3db4b0a1-bc42-4302-9b84-ea3eece9ce87",
			title: "AWS Sandbox Accounts",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_account with master=true\nthat has aws_account with _source='system-mapper' as a\nreturn count(a) as value"
					}
				]
			}
		},
		{
			id: "d80ca0be-1524-42a2-94de-800d7444ac1a",
			title: "Validated External Vendor Accounts",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_account with _source='system-mapper' and validated=true as a\nthat !has aws_account\nreturn count(a) as value"
					}
				],
				settings: {
					number: {
						warning: {
							limitCondition: "greaterThan",
							val1: "0"
						}
					}
				}
			}
		},
		{
			id: "076193c7-1bea-43f7-a699-0669fe151abf",
			title: "Unvalidated External Vendor Accounts",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_account with _source='system-mapper' and validated!=true as a\nthat !has aws_account\nreturn count(a) as value"
					}
				],
				settings: {
					number: {
						error: {
							limitCondition: "greaterThan",
							val1: "0"
						}
					}
				}
			}
		}
	];
	var layouts$i = {
		sm: [
			{
				x: 0,
				h: 2,
				i: "39e8c4ac-66ac-442f-890b-8d613daf9d57",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "c4b6fc77-f8b2-4bef-8092-f5aafa1a2b52",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "6d442eea-2404-4053-b8b1-ee7ab3e94d8b",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "85247439-d5cc-4bf8-ac8d-71bb12c64f0e",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "397f5108-a367-4c86-ab14-4d1d1cd01d54",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "3db4b0a1-bc42-4302-9b84-ea3eece9ce87",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "d80ca0be-1524-42a2-94de-800d7444ac1a",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "076193c7-1bea-43f7-a699-0669fe151abf",
				y: 1000000000000,
				w: 2
			}
		],
		xs: [
		],
		lg: [
			{
				"static": false,
				w: 10,
				moved: false,
				h: 2,
				x: 2,
				y: 1,
				i: "39e8c4ac-66ac-442f-890b-8d613daf9d57"
			},
			{
				"static": false,
				w: 10,
				moved: false,
				h: 2,
				x: 2,
				y: 3,
				i: "c4b6fc77-f8b2-4bef-8092-f5aafa1a2b52"
			},
			{
				"static": false,
				w: 8,
				moved: false,
				h: 2,
				x: 4,
				y: 5,
				i: "6d442eea-2404-4053-b8b1-ee7ab3e94d8b"
			},
			{
				"static": false,
				w: 12,
				moved: false,
				h: 1,
				x: 0,
				y: 0,
				i: "85247439-d5cc-4bf8-ac8d-71bb12c64f0e"
			},
			{
				"static": false,
				w: 2,
				moved: false,
				h: 2,
				x: 0,
				y: 1,
				i: "397f5108-a367-4c86-ab14-4d1d1cd01d54"
			},
			{
				"static": false,
				w: 2,
				moved: false,
				h: 2,
				x: 0,
				y: 3,
				i: "3db4b0a1-bc42-4302-9b84-ea3eece9ce87"
			},
			{
				"static": false,
				w: 2,
				moved: false,
				h: 2,
				x: 0,
				y: 5,
				i: "d80ca0be-1524-42a2-94de-800d7444ac1a"
			},
			{
				"static": false,
				w: 2,
				moved: false,
				h: 2,
				x: 2,
				y: 5,
				i: "076193c7-1bea-43f7-a699-0669fe151abf"
			}
		],
		xl: [
		],
		md: [
		]
	};
	var awsAccountBoard = {
		widgets: widgets$i,
		layouts: layouts$i
	};

	var widgets$h = [
		{
			id: "0f10330f-7587-4216-8743-48b3a2156c0e",
			title: "Users assigned \"Support\" role to AWS",
			type: "table",
			config: {
				queries: [
					{
						name: "query0",
						query: "Find okta_user as u that assigned aws_iam_role with name='Support'\nreturn\n  u.name as Name,\n  u.email as Email"
					}
				]
			}
		},
		{
			id: "2f32d784-62e1-4e61-a4d4-411800e7e35f",
			title: "Users assigned AWS Admin Access",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "'admin' with _type='aws_iam_role' as r that assigned okta_user as u \nreturn r._type, r.name, u._type, u.name"
					}
				]
			}
		},
		{
			id: "e52f89d1-9b8a-4e2e-8bd8-4ea6be3d8852",
			title: "Number of IAM Roles by Account",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_iam_role as role\n  return role.tag.AccountName as name, count(role) as value"
					}
				]
			}
		},
		{
			id: "3fb7564f-b120-4d59-ac44-6e4fcb238481",
			title: "Number of IAM Users by Account",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_iam_user as user\n  return user.tag.AccountName as name, count(user) as value"
					}
				]
			}
		},
		{
			id: "0c4c846f-6d3d-468d-81be-d408f82dbdc1",
			title: "AWS User or Role with inline policies",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find (User|AccessRole) as u\n  that (has|assigned) (aws_iam_user_policy|aws_iam_role_policy) as p\n  return u.tag.AccountName, u._type, u.name, p.name\n  order by u.tag.AccountName"
					}
				]
			}
		},
		{
			id: "40982e7a-f5ce-4d31-ac02-d90e1da7f543",
			title: "Number of IAM groups by Account",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_iam_group as group\n  return group.tag.AccountName as name, count(group) as value"
					}
				]
			}
		},
		{
			id: "672f82ce-3a15-4f50-a0ed-a438cc45cbf7",
			title: "AWS policy assignment to Okta Users",
			type: "bar",
			config: {
				queries: [
					{
						name: "query0",
						query: "Find okta_user as user that assigned aws_iam_role as role that assigned aws_iam_policy as policy\nreturn policy.displayName as x, count(user) as y"
					}
				]
			}
		},
		{
			id: "51c4e0a2-8acb-4a60-94fb-b7a6e25f5ddb",
			title: "Users or Roles assigned Admin Access Policy",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find AccessPolicy with admin=true as policy \n  that ASSIGNED * as entity\nreturn\n  entity._type, entity.displayName, entity.webLink,\n  policy.tag.AccountName as account,\n  policy.displayName, policy.webLink"
					}
				]
			}
		}
	];
	var layouts$h = {
		sm: [
		],
		xs: [
		],
		lg: [
			{
				"static": false,
				w: 4,
				moved: false,
				h: 3,
				x: 8,
				y: 2,
				i: "0f10330f-7587-4216-8743-48b3a2156c0e"
			},
			{
				"static": false,
				w: 7,
				moved: false,
				h: 2,
				x: 5,
				y: 8,
				i: "2f32d784-62e1-4e61-a4d4-411800e7e35f"
			},
			{
				"static": false,
				w: 4,
				moved: false,
				h: 2,
				x: 8,
				y: 0,
				i: "e52f89d1-9b8a-4e2e-8bd8-4ea6be3d8852"
			},
			{
				"static": false,
				w: 4,
				moved: false,
				h: 2,
				x: 4,
				y: 0,
				i: "3fb7564f-b120-4d59-ac44-6e4fcb238481"
			},
			{
				"static": false,
				w: 8,
				moved: false,
				h: 3,
				x: 0,
				y: 2,
				i: "0c4c846f-6d3d-468d-81be-d408f82dbdc1"
			},
			{
				"static": false,
				w: 4,
				moved: false,
				h: 2,
				x: 0,
				y: 0,
				i: "40982e7a-f5ce-4d31-ac02-d90e1da7f543"
			},
			{
				"static": false,
				w: 5,
				moved: false,
				h: 2,
				x: 0,
				y: 8,
				i: "672f82ce-3a15-4f50-a0ed-a438cc45cbf7"
			},
			{
				"static": false,
				w: 12,
				moved: false,
				h: 3,
				x: 0,
				y: 5,
				i: "51c4e0a2-8acb-4a60-94fb-b7a6e25f5ddb"
			}
		],
		xl: [
		],
		md: [
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 0,
				i: "0"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 2,
				i: "1"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 4,
				i: "2"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 6,
				i: "3"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 8,
				i: "4"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 10,
				i: "5"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 12,
				i: "6"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 14,
				i: "7"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 16,
				i: "8"
			}
		]
	};
	var awsIamBoard = {
		widgets: widgets$h,
		layouts: layouts$h
	};

	var widgets$g = [
		{
			id: "5712418e-a7f2-4d74-a8b8-5c00631a102d",
			title: "Number of Active EC2 Instances by Account",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_instance with active=true as e\nreturn e.tag.AccountName as name, count(e) as value"
					}
				]
			}
		},
		{
			id: "2ecc8cc5-a7ea-49ed-90c9-95f006d2fde7",
			title: "Recently terminated EC2 instances by account",
			type: "bar",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_instance with state='terminated' as i\nreturn i.tag.AccountName as x, count(i) as y"
					}
				]
			}
		},
		{
			id: "fe23cb32-30b9-4566-a62f-7c5fc2d356fa",
			title: "ENI Count by Account",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_eni as e\nreturn e.tag.AccountName as name, count(e) as value"
					}
				]
			}
		},
		{
			id: "b7b03760-d78e-4bec-aea3-c66197183659",
			title: "Unused ENI Count by Account",
			type: "bar",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_eni as e that !USES (Host|Gateway|Function|Database|Cluster|Task)\nreturn e.tag.AccountName as x, count(e) as y"
					}
				]
			}
		},
		{
			id: "58db1b5c-b9f9-4822-897d-61b3948bd691",
			title: "Unused EBS volumes by account",
			type: "bar",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_ebs_volume as v that !uses aws_instance\nreturn v.tag.AccountName as x, count(v) as y"
					}
				]
			}
		},
		{
			id: "0d2004c1-7197-4c96-badd-56a812899826",
			title: "EBS Snapshots shared with another account",
			type: "bar",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_ebs_snapshot with shared=true as ebs\nreturn count(ebs) as value"
					}
				]
			}
		},
		{
			id: "ef754139-0bce-4e9c-a324-b1563fd5497c",
			title: "EBS Snapshots shared publicly with everyone",
			type: "bar",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_ebs_snapshot with public=true as ebs\nreturn count(ebs) as value"
					}
				]
			}
		},
		{
			id: "3985ddfb-aa43-4afd-919a-fb618d9104dc",
			title: "Number of S3 buckets by account",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "FIND aws_s3_bucket as bkt\nRETURN\n  bkt.tag.AccountName AS name,\n  count(bkt) AS value"
					}
				]
			}
		},
		{
			id: "07a697c8-603d-42d3-857c-065588b11833",
			title: "Number of lambda functions by Runtime",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_lambda_function as f\nReturn\n  f.runtime as name,\n  count(f) as value"
					}
				]
			}
		},
		{
			id: "701db542-4f17-4d3e-9155-2186409d35a2",
			title: "Number of lambda functions by VPC",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_lambda_function as f that HAS aws_vpc as v\nReturn\nv.name as name,\ncount(f) as value"
					}
				]
			}
		},
		{
			id: "d4fb5306-fbf1-4aa7-81cb-0fb6ac377051",
			title: "Number of Lambda Functions not connected to a VPC",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_lambda_function with VpcId=undefined or VpcId='' as f\nReturn\nf.tag.AccountName as name,\ncount(f) as value"
					}
				]
			}
		},
		{
			id: "d7b8dd7d-d9ee-476b-97a6-aa37a87a962d",
			title: "RDS instances count by size",
			type: "bar",
			config: {
				queries: [
					{
						name: "query1",
						query: "find aws_db_instance as i\nreturn i.dbInstanceClass as x, count(i) as y"
					}
				]
			}
		},
		{
			id: "f8214f43-ddcd-40f1-bd21-1f86a66c6268",
			title: "Production RDS instances count by cluster name",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_rds_cluster with tag.Production=true as c \nthat contains aws_db_instance as i\nreturn c.displayName as name, count(i) as value"
					}
				]
			}
		}
	];
	var layouts$g = {
		sm: [
		],
		xs: [
		],
		lg: [
			{
				x: 0,
				h: 2,
				i: "5712418e-a7f2-4d74-a8b8-5c00631a102d",
				y: 0,
				w: 4
			},
			{
				x: 4,
				h: 2,
				i: "2ecc8cc5-a7ea-49ed-90c9-95f006d2fde7",
				y: 0,
				w: 8
			},
			{
				x: 0,
				h: 2,
				i: "fe23cb32-30b9-4566-a62f-7c5fc2d356fa",
				y: 2,
				w: 4
			},
			{
				x: 4,
				h: 2,
				i: "b7b03760-d78e-4bec-aea3-c66197183659",
				y: 2,
				w: 8
			},
			{
				x: 0,
				h: 2,
				i: "58db1b5c-b9f9-4822-897d-61b3948bd691",
				y: 4,
				w: 6
			},
			{
				x: 6,
				h: 2,
				i: "0d2004c1-7197-4c96-badd-56a812899826",
				y: 4,
				w: 6
			},
			{
				x: 0,
				h: 2,
				i: "ef754139-0bce-4e9c-a324-b1563fd5497c",
				y: 6,
				w: 8
			},
			{
				x: 8,
				h: 2,
				i: "3985ddfb-aa43-4afd-919a-fb618d9104dc",
				y: 6,
				w: 4
			},
			{
				x: 0,
				h: 2,
				i: "07a697c8-603d-42d3-857c-065588b11833",
				y: 8,
				w: 4
			},
			{
				x: 4,
				h: 2,
				i: "701db542-4f17-4d3e-9155-2186409d35a2",
				y: 8,
				w: 4
			},
			{
				x: 8,
				h: 2,
				i: "d4fb5306-fbf1-4aa7-81cb-0fb6ac377051",
				y: 8,
				w: 4
			},
			{
				x: 0,
				h: 2,
				i: "d7b8dd7d-d9ee-476b-97a6-aa37a87a962d",
				y: 10,
				w: 8
			},
			{
				x: 8,
				h: 2,
				i: "f8214f43-ddcd-40f1-bd21-1f86a66c6268",
				y: 10,
				w: 4
			}
		],
		xl: [
		],
		md: [
		]
	};
	var awsResourcesBoard = {
		widgets: widgets$g,
		layouts: layouts$g
	};

	var widgets$f = [
		{
			id: "5f4a0105-c7f3-4cdf-a40e-2bf8c04a2493",
			title: "S3 Buckets without SecureTransport Enabled",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_s3_bucket with secureTransport != true as bucket\nreturn bucket.tag.AccountName as name, count(bucket) as value"
					}
				]
			}
		},
		{
			id: "de813b92-a04b-411f-b877-e5d807f9ba57",
			title: "Non-public buckets exposed publicly",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_s3_bucket \n  with classification != 'public' and\n    ignorePublicAcls != true and \n    restrictPublicBuckets != true\n  as bucket\nthat ALLOWS as grant everyone \nreturn \n  bucket.displayName, bucket.tag.AccountName, bucket.classification,\n  grant.permission, grant.granteeType, grant.granteeURI"
					}
				]
			}
		},
		{
			id: "14d18176-047b-4b7f-8570-78779055c0cb",
			title: "S3 buckets granted full access to someone other than the owner account",
			type: "graph",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_s3_bucket with _source!='system-mapper' as bucket \n  that ALLOWS as grant * as grantee\n  (that ASSIGNED * as principal)?\nwhere \n  bucket.accountId != grantee.accountId or\n  (principal._type!=undefined and bucket.accountId != principal.accountId)\nreturn tree\n"
					}
				]
			}
		},
		{
			id: "38653008-7237-4223-84cf-be1d099089f6",
			title: "S3 buckets containing CloudTrail Logs",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "find aws_s3_bucket that (logs|allows) aws_cloudtrail \n"
					}
				]
			}
		},
		{
			id: "175c65ae-2fdd-48b0-8bc1-1cb9b827c02f",
			title: "Unencrypted S3 buckets containing CloudTrail logs",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "find aws_s3_bucket with encrypted!=true that (logs|allows) aws_cloudtrail \n"
					}
				]
			}
		},
		{
			id: "06c004dc-aaa7-4978-beda-168d068b166e",
			title: "S3 buckets containing CloudTrail Logs",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "find unique aws_s3_bucket that (logs|allows) aws_cloudtrail \nreturn count(aws_s3_bucket) as value"
					}
				],
				settings: {
					number: {
						"default": {
							limitCondition: "greaterThan",
							val1: 0
						}
					}
				}
			}
		},
		{
			id: "8d837010-033f-4cd1-a8e5-7ddecad49748",
			title: "Unencrypted S3 buckets containing CloudTrail Logs",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "find unique aws_s3_bucket with encrypted!=true that (logs|allows) aws_cloudtrail \nreturn count(aws_s3_bucket) as value"
					}
				],
				settings: {
					number: {
						error: {
							limitCondition: "greaterThan",
							val1: 0
						}
					}
				}
			}
		},
		{
			id: "0eebbe4b-30bf-4e6a-9470-df7e21622c96",
			title: "Non-public S3 buckets exposed via public facing EC2 instances",
			type: "graph",
			config: {
				queries: [
					{
						name: "query1",
						query: "find Internet \n  that allows aws_security_group \n  that protects aws_instance with active=true \n  that uses aws_iam_role that assigned AccessPolicy \n  that allows (aws_s3|aws_s3_bucket) with classification!='public' \nreturn tree\n"
					}
				]
			}
		},
		{
			id: "cdee5cb9-919f-4c88-a70a-f15befaf750b",
			title: "Top 10 largest (most expensive) S3 buckets",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "find aws_s3_bucket with bucketSizeBytes != undefined as bucket \nreturn \n  bucket.name, bucket.tag.AccountName, \n  bucket.numberOfObjects, bucket.bucketSizeBytes, \n  bucket.bucketSizeBytes / 1000000000 * 0.023 as monthlyCost,\n  bucket.lifecycleEnabled, bucket.retentionPeriod, bucket.webLink\norder by bucket.bucketSizeBytes DESC limit 10\n"
					}
				]
			}
		},
		{
			id: "844d3825-927d-4207-8e33-7a0c9022a6c8",
			title: "S3 buckets hosting static content for CloudFront distribution (CDN)",
			type: "graph",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_cloudfront_distribution that connects aws_s3_bucket\nreturn tree\n"
					}
				]
			}
		},
		{
			id: "84cef726-d7cf-43ac-a7c8-c79b35020568",
			title: "Non-public buckets with Objects that can be public",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_s3_bucket \n  with classification != 'public' and\n    ignorePublicAcls != true and \n    restrictPublicBuckets != true\n  as bucket\nreturn \n  bucket.displayName, \n  bucket.tag.AccountName, \n  bucket.classification, \n  bucket.webLink"
					}
				]
			}
		},
		{
			id: "5d1e97fb-ea8c-4e50-9ef4-6dfa427fe2d8",
			title: "S3 buckets without default encryption enabled",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_s3_bucket with encrypted != true as bucket\nreturn bucket.tag.AccountName as name, count(bucket) as value"
					}
				]
			}
		},
		{
			id: "71ca9e29-5413-4976-bf10-d8ed27ac8506",
			title: "Buckets granted access to AWS services without source condition",
			type: "graph",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_s3_bucket as bucket\nthat allows Service \n  with name = ('serverlessrepo' or 'cloudtrail' or 'config')\nwhere \n  allows.conditions = undefined or (\n  allows.conditions !~= 'aws:SourceAccount' and \n  allows.conditions !~= 'aws:PrincipalOrgId' and\n  allows.conditions !~= bucket.accountId\n  )\nreturn tree\n"
					}
				]
			}
		},
		{
			id: "46154f6c-4452-4d71-a269-4d6a58e41e14",
			title: "Public buckets with sensitive data or secrets",
			type: "graph",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find (Everyone|aws_cloudfront_distribution)\nthat (allows|connects) aws_s3_bucket \nthat has Finding \n  with hasSecrets=true or hasSensitiveData=true\nreturn tree"
					}
				]
			}
		},
		{
			id: "37eebce1-b495-4db5-9497-d1744e408d8d",
			title: "S3 cross account access via VPC peering",
			type: "graph",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find (aws_s3|aws_s3_bucket) \n  that allows aws_vpc_endpoint\n  that has aws_vpc\n  that connects aws_vpc\nreturn TREE"
					}
				]
			}
		},
		{
			id: "c8c96d7f-fccd-4c53-98d0-cf69ceb8d097",
			title: "SAML SSO users with access to prod s3 buckets",
			type: "graph",
			config: {
				queries: [
					{
						name: "query1",
						query: "find okta_user that assigned AccessRole\n  that assigned AccessPolicy\n  that allows (aws_s3|aws_s3_bucket|aws_account) with tag.Production=true\n  (that has aws_s3)?\n  (that has aws_s3_bucket)?\nreturn tree"
					}
				]
			}
		},
		{
			id: "88c50e88-46aa-496e-80bf-efa530849e59",
			title: "S3 buckets with server access logging enabled",
			type: "graph",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_s3_bucket that logs to aws_s3_bucket\nreturn tree"
					}
				]
			}
		},
		{
			id: "701bc5e9-b00b-4b8c-9cdb-8b2dc01986ee",
			title: "S3 buckets with object level logging enabled",
			type: "graph",
			config: {
				queries: [
					{
						name: "query1",
						query: "find aws_s3_bucket \nthat sends aws_cloudtrail \nthat logs to * \nreturn TREE"
					}
				]
			}
		},
		{
			id: "9a05e25e-a833-46c4-8d8c-ce163086511b",
			title: "Production S3 buckets without any logging enabled",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_s3_bucket with loggingEnabled!=true and tag.Production=true"
					}
				]
			}
		},
		{
			id: "d3b2e2e0-4f7e-463a-876f-ebeae3f81602",
			title: "S3 buckets publishing inventory reports",
			type: "graph",
			config: {
				queries: [
					{
						name: "query1",
						query: "find aws_s3_bucket that publishes to >> aws_s3_bucket\nreturn tree"
					}
				]
			}
		}
	];
	var layouts$f = {
		sm: [
		],
		xs: [
		],
		lg: [
			{
				"static": false,
				w: 4,
				moved: false,
				h: 2,
				x: 0,
				y: 0,
				i: "5f4a0105-c7f3-4cdf-a40e-2bf8c04a2493"
			},
			{
				"static": false,
				w: 8,
				moved: false,
				h: 2,
				x: 4,
				y: 0,
				i: "de813b92-a04b-411f-b877-e5d807f9ba57"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 4,
				x: 0,
				y: 4,
				i: "14d18176-047b-4b7f-8570-78779055c0cb"
			},
			{
				"static": false,
				w: 9,
				moved: false,
				h: 3,
				x: 3,
				y: 19,
				i: "38653008-7237-4223-84cf-be1d099089f6"
			},
			{
				"static": false,
				w: 9,
				moved: false,
				h: 2,
				x: 3,
				y: 22,
				i: "175c65ae-2fdd-48b0-8bc1-1cb9b827c02f"
			},
			{
				"static": false,
				w: 3,
				moved: false,
				h: 3,
				x: 0,
				y: 19,
				i: "06c004dc-aaa7-4978-beda-168d068b166e"
			},
			{
				"static": false,
				w: 3,
				moved: false,
				h: 2,
				x: 0,
				y: 22,
				i: "8d837010-033f-4cd1-a8e5-7ddecad49748"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 4,
				x: 6,
				y: 8,
				i: "0eebbe4b-30bf-4e6a-9470-df7e21622c96"
			},
			{
				"static": false,
				w: 8,
				moved: false,
				h: 3,
				x: 4,
				y: 28,
				i: "cdee5cb9-919f-4c88-a70a-f15befaf750b"
			},
			{
				"static": false,
				w: 12,
				moved: false,
				h: 3,
				x: 0,
				y: 16,
				i: "844d3825-927d-4207-8e33-7a0c9022a6c8"
			},
			{
				"static": false,
				w: 8,
				moved: false,
				h: 2,
				x: 4,
				y: 2,
				i: "84cef726-d7cf-43ac-a7c8-c79b35020568"
			},
			{
				"static": false,
				w: 4,
				moved: false,
				h: 2,
				x: 0,
				y: 2,
				i: "5d1e97fb-ea8c-4e50-9ef4-6dfa427fe2d8"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 4,
				x: 0,
				y: 12,
				i: "71ca9e29-5413-4976-bf10-d8ed27ac8506"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 4,
				x: 6,
				y: 12,
				i: "46154f6c-4452-4d71-a269-4d6a58e41e14"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 4,
				x: 6,
				y: 4,
				i: "37eebce1-b495-4db5-9497-d1744e408d8d"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 4,
				x: 0,
				y: 8,
				i: "c8c96d7f-fccd-4c53-98d0-cf69ceb8d097"
			},
			{
				"static": false,
				w: 4,
				moved: false,
				h: 4,
				x: 8,
				y: 24,
				i: "88c50e88-46aa-496e-80bf-efa530849e59"
			},
			{
				"static": false,
				w: 4,
				moved: false,
				h: 4,
				x: 4,
				y: 24,
				i: "701bc5e9-b00b-4b8c-9cdb-8b2dc01986ee"
			},
			{
				"static": false,
				w: 4,
				moved: false,
				h: 4,
				x: 0,
				y: 24,
				i: "9a05e25e-a833-46c4-8d8c-ce163086511b"
			},
			{
				"static": false,
				w: 4,
				moved: false,
				h: 3,
				x: 0,
				y: 28,
				i: "d3b2e2e0-4f7e-463a-876f-ebeae3f81602"
			}
		],
		xl: [
		],
		md: [
		]
	};
	var awsS3Security = {
		widgets: widgets$f,
		layouts: layouts$f
	};

	var widgets$e = [
		{
			id: "6e65ec84-3f81-49bb-8663-84a7019461f8",
			title: "All Licenses by Package",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find UNIQUE CodeRepo \nTHAT USES npm_package AS p \nRETURN p.name as Package, p.license as License, count(CodeRepo) as UsageCount\nORDER BY p.license ASC"
					}
				]
			}
		},
		{
			id: "34840786-08c5-435a-b259-1da611a60143",
			title: "Unique Licenses Used by Direct Dependencies",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "FIND UNIQUE CodeRepo \nTHAT USES npm_package with license != 'unset' and license != 'UNLICENSED' as p \nreturn p.license as License\nORDER BY p.license ASC"
					}
				]
			}
		},
		{
			id: "f5228a40-396f-4c3e-ad1e-799e16445e20",
			title: "Total Unique Production NPM Dependencies",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find UNIQUE CodeRepo THAT USES as u npm_package AS p WHERE u.devDependency != true RETURN COUNT(p) AS value"
					}
				]
			}
		},
		{
			id: "18484870-a5ba-4df4-b8a1-511c6d1e4d4f",
			title: "License Usage",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "FIND CodeRepo \nTHAT USES as u npm_package as p \nWHERE u.devDependency != true\nRETURN p.license as name, count(p) as value"
					}
				]
			}
		}
	];
	var layouts$e = {
		sm: [
		],
		xs: [
			{
				"static": false,
				w: 1,
				moved: false,
				h: 2,
				x: 0,
				y: 0,
				i: "6e65ec84-3f81-49bb-8663-84a7019461f8"
			},
			{
				"static": false,
				w: 1,
				moved: false,
				h: 2,
				x: 0,
				y: 2,
				i: "34840786-08c5-435a-b259-1da611a60143"
			},
			{
				"static": false,
				w: 1,
				moved: false,
				h: 2,
				x: 0,
				y: 4,
				i: "f5228a40-396f-4c3e-ad1e-799e16445e20"
			},
			{
				"static": false,
				w: 1,
				moved: false,
				h: 2,
				x: 0,
				y: 6,
				i: "18484870-a5ba-4df4-b8a1-511c6d1e4d4f"
			}
		],
		lg: [
			{
				"static": false,
				w: 4,
				moved: false,
				h: 7,
				x: 4,
				y: 0,
				i: "6e65ec84-3f81-49bb-8663-84a7019461f8"
			},
			{
				"static": false,
				w: 4,
				moved: false,
				h: 7,
				x: 8,
				y: 0,
				i: "34840786-08c5-435a-b259-1da611a60143"
			},
			{
				"static": false,
				w: 4,
				moved: false,
				h: 2,
				x: 0,
				y: 0,
				i: "f5228a40-396f-4c3e-ad1e-799e16445e20"
			},
			{
				"static": false,
				w: 4,
				moved: false,
				h: 5,
				x: 0,
				y: 2,
				i: "18484870-a5ba-4df4-b8a1-511c6d1e4d4f"
			}
		],
		xl: [
		],
		md: [
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 0,
				i: "6e65ec84-3f81-49bb-8663-84a7019461f8"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 2,
				i: "34840786-08c5-435a-b259-1da611a60143"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 4,
				i: "f5228a40-396f-4c3e-ad1e-799e16445e20"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 6,
				i: "18484870-a5ba-4df4-b8a1-511c6d1e4d4f"
			}
		]
	};
	var codeDepsBoard = {
		widgets: widgets$e,
		layouts: layouts$e
	};

	var widgets$d = [
		{
			id: "99644fe4-ee6c-4595-96d4-e221b0469a29",
			title: "Potential cost of data breach in public-facing and unencrypted data stores",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find Finding with open!=false and hasSensitiveData=true and \n  numericSeverity>5 and extension!='js' and\n  (public=true or encrypted!=true)\nreturn sum(Finding.detectionsCount) * 142 as value"
					}
				],
				settings: {
					number: {
						error: {
							limitCondition: "greaterThanOrEqualTo",
							val1: 1000000
						},
						warning: {
							limitCondition: "between",
							val2: 999999,
							val1: 100000
						},
						currencyFormat: "$"
					}
				}
			}
		},
		{
			id: "e6b14510-23a8-4de9-a7f5-b50b8b26d606",
			title: "Sensitive data that may be publicly accessible or unencrypted",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find unique Finding with open!=false and hasSensitiveData=true \n  and numericSeverity>5 and extension!='js' and\n  (public=true or encrypted!=true)\nreturn \n  Finding._type, Finding.name, Finding.severity, Finding.file, Finding.path,\n  Finding.PII, Finding.PCI, Finding.secret"
					}
				]
			}
		},
		{
			id: "0341141c-81dd-46e6-bf74-02518b1f190b",
			title: "Sensitive data records in public or unencrypted data stores",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find Finding with open!=false and hasSensitiveData=true and \n  numericSeverity>5 and extension!='js' and\n  (public=true or encrypted!=true)\nreturn sum(Finding.detectionsCount) as value"
					}
				]
			}
		}
	];
	var layouts$d = {
		sm: [
		],
		xs: [
		],
		lg: [
			{
				"static": false,
				w: 7,
				moved: false,
				h: 2,
				x: 5,
				y: 0,
				i: "99644fe4-ee6c-4595-96d4-e221b0469a29"
			},
			{
				"static": false,
				w: 12,
				moved: false,
				h: 5,
				x: 0,
				y: 2,
				i: "e6b14510-23a8-4de9-a7f5-b50b8b26d606"
			},
			{
				"static": false,
				w: 5,
				moved: false,
				h: 2,
				x: 0,
				y: 0,
				i: "0341141c-81dd-46e6-bf74-02518b1f190b"
			}
		],
		xl: [
		],
		md: [
		]
	};
	var dataBreachCostBoard = {
		widgets: widgets$d,
		layouts: layouts$d
	};

	var widgets$c = [
		{
			id: "5c49bc63-eb74-4fc3-87cf-4a453dfd80e9",
			title: "Number of data stores by account",
			type: "pie",
			config: {
				queries: [
					{
						name: "query0",
						query: "FIND DataStore AS ds\n        RETURN\n        ds.tag.AccountName as name,\n        count(ds) AS value"
					}
				]
			}
		},
		{
			id: "e9faca7f-a237-4b21-8ec4-184b25c077f7",
			title: "Unclassified data stores by account",
			type: "pie",
			config: {
				queries: [
					{
						name: "query0",
						query: "Find DataStore with classification=undefined as ds\n        return\n          ds.tag.AccountName as name,\n          count(ds) as value"
					}
				]
			}
		},
		{
			id: "e933256a-2a69-46d1-82c4-4f0e1743fa18",
			title: "Unencrypted data stores by type",
			type: "pie",
			config: {
				queries: [
					{
						name: "query0",
						query: "Find DataStore with encrypted=false as ds\n        return\n        ds._type as name,\n        count(ds) as value"
					}
				]
			}
		},
		{
			id: "3d167e1b-1999-4f37-b312-ddca51f00383",
			title: "Unencrypted data stores by account",
			type: "pie",
			config: {
				queries: [
					{
						name: "query0",
						query: "Find DataStore with encrypted=false as ds\n        return\n          ds.tag.AccountName as name,\n          count(ds) as value"
					}
				]
			}
		},
		{
			id: "3d81394c-7773-4b8e-87d7-3d909595cfda",
			title: "Non-public data stores with public access",
			type: "table",
			config: {
				queries: [
					{
						name: "query0",
						query: "Find DataStore with (classification!='public' or classification=undefined) as ds\n  that ALLOWS everyone\nreturn ds._type, ds.name, ds.tag.AccountName, ds.encrypted, ds.createdOn, ds.webLink"
					}
				]
			}
		},
		{
			id: "7a4c72e0-57c5-4fd9-ae04-bffa7b220b34",
			title: "Unencrypted Data Stores in Production",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find DataStore with encrypted=false and tag.Production=true as ds\nreturn\n  count(ds) as value"
					}
				],
				settings: {
					number: {
						error: {
							limitCondition: "greaterThan",
							val1: 0
						}
					}
				}
			}
		}
	];
	var layouts$c = {
		sm: [
			{
				x: 0,
				h: 2,
				i: "5c49bc63-eb74-4fc3-87cf-4a453dfd80e9",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "e9faca7f-a237-4b21-8ec4-184b25c077f7",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "e933256a-2a69-46d1-82c4-4f0e1743fa18",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "3d167e1b-1999-4f37-b312-ddca51f00383",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "3d81394c-7773-4b8e-87d7-3d909595cfda",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "7a4c72e0-57c5-4fd9-ae04-bffa7b220b34",
				y: 1000000000000,
				w: 2
			}
		],
		xs: [
		],
		lg: [
			{
				w: 3,
				h: 3,
				x: 0,
				y: 0,
				i: "5c49bc63-eb74-4fc3-87cf-4a453dfd80e9",
				moved: false,
				"static": false
			},
			{
				w: 3,
				h: 3,
				x: 3,
				y: 0,
				i: "e9faca7f-a237-4b21-8ec4-184b25c077f7",
				moved: false,
				"static": false
			},
			{
				w: 3,
				h: 3,
				x: 9,
				y: 0,
				i: "e933256a-2a69-46d1-82c4-4f0e1743fa18",
				moved: false,
				"static": false
			},
			{
				w: 3,
				h: 3,
				x: 6,
				y: 0,
				i: "3d167e1b-1999-4f37-b312-ddca51f00383",
				moved: false,
				"static": false
			},
			{
				w: 9,
				h: 2,
				x: 3,
				y: 3,
				i: "3d81394c-7773-4b8e-87d7-3d909595cfda",
				moved: false,
				"static": false
			},
			{
				w: 3,
				h: 2,
				x: 0,
				y: 3,
				i: "7a4c72e0-57c5-4fd9-ae04-bffa7b220b34",
				moved: false,
				"static": false
			}
		],
		xl: [
		],
		md: [
		]
	};
	var dataProtectionBoard = {
		widgets: widgets$c,
		layouts: layouts$c
	};

	var widgets$b = [
		{
			id: "e06623f1-8c59-43cd-ae78-4df47edfe31b",
			title: "Number of Code Repos by Project",
			type: "pie",
			config: {
				queries: [
					{
						name: "query0",
						query: "FIND CodeRepo AS repo that has (Project|Account) as p\n        RETURN\n        p.name as name,\n        count(repo) AS value"
					}
				]
			}
		},
		{
			id: "e1dc29f2-4de1-4ae7-8adf-75e9bf6dff4c",
			title: "PRs containing self-approved commits that merged last month",
			type: "number",
			config: {
				queries: [
					{
						name: "query0",
						query: "Find PR with\n    approved=false and merged=true and updatedOn > date.now-30days as pr\nreturn count(pr) as value"
					}
				],
				settings: {
					number: {
						warning: {
							limitCondition: "greaterThan",
							val1: 0
						}
					}
				}
			}
		},
		{
			id: "9ee0574f-ba9d-40af-b967-f7b16e260ce7",
			title: "Top Open PRs by Developer",
			type: "bar",
			config: {
				settings: {
					view: "bar"
				},
				queries: [
					{
						name: "query0",
						query: "FIND Person AS p\n  THAT IS User AS u\n  THAT opened PR WITH state='OPEN' AS pr\nRETURN\n  p.displayName AS x,\n  count(pr) AS y\nORDER BY y DESC\nLIMIT 10"
					}
				]
			}
		},
		{
			id: "a5695fd3-930a-4aa3-a242-e8cae8b31fd7",
			title: "PRs containing commits from unvalidated developers last month",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find PR with\n    validated=false and updatedOn > date.now-30days as pr\nreturn count(pr) as value"
					}
				],
				settings: {
					number: {
						error: {
							limitCondition: "greaterThan",
							val1: 0
						}
					}
				}
			}
		},
		{
			id: "c5c83cbf-8b08-41ea-b479-5ea751bacb21",
			title: "PRs containing self-approved commits that merged last month",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find PR with\n    approved=false and merged=true and updatedOn > date.now-30days"
					}
				]
			}
		},
		{
			id: "afa6db8f-225f-41a2-b378-0a0e61ef0b99",
			title: "PRs containing commits from unvalidated developers last month",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find PR with\n    validated=false and updatedOn > date.now-30days"
					}
				]
			}
		}
	];
	var layouts$b = {
		sm: [
		],
		xs: [
		],
		lg: [
			{
				w: 4,
				h: 3,
				x: 0,
				y: 0,
				i: "e06623f1-8c59-43cd-ae78-4df47edfe31b",
				moved: false,
				"static": false
			},
			{
				w: 4,
				h: 3,
				x: 0,
				y: 3,
				i: "e1dc29f2-4de1-4ae7-8adf-75e9bf6dff4c",
				moved: false,
				"static": false
			},
			{
				w: 8,
				h: 3,
				x: 4,
				y: 0,
				i: "9ee0574f-ba9d-40af-b967-f7b16e260ce7",
				moved: false,
				"static": false
			},
			{
				w: 4,
				h: 3,
				x: 0,
				y: 6,
				i: "a5695fd3-930a-4aa3-a242-e8cae8b31fd7",
				moved: false,
				"static": false
			},
			{
				w: 8,
				h: 3,
				x: 4,
				y: 3,
				i: "c5c83cbf-8b08-41ea-b479-5ea751bacb21",
				moved: false,
				"static": false
			},
			{
				w: 8,
				h: 3,
				x: 4,
				y: 6,
				i: "afa6db8f-225f-41a2-b378-0a0e61ef0b99",
				moved: false,
				"static": false
			}
		],
		xl: [
		],
		md: [
		]
	};
	var developmentBoard = {
		widgets: widgets$b,
		layouts: layouts$b
	};

	var widgets$a = [
		{
			id: "4120fbd6-640b-481a-b0ce-e58269557009",
			title: "Internet Access",
			type: "matrix",
			config: {
				queries: [
					{
						name: "query1",
						query: "FIND Firewall AS row\nTHAT allows AS rel\nInternet AS col\nRETURN\nrow.displayName AS x,\ncol.displayName AS y,\nrel.egress AS egress,\nrel.ingress AS ingress,\nrel.fromPort as fromPort,\nrel.toPort as toPort,\nrel.ipProtocol AS label"
					}
				]
			}
		},
		{
			id: "037bfad3-36c4-4f04-9155-abc3d9c7a302",
			title: "Firewall Matrix - External",
			type: "matrix",
			config: {
				queries: [
					{
						name: "query1",
						query: "FIND Firewall AS row\nTHAT allows AS rel\nNetwork with public=true or _source='system-mapper' AS col\nRETURN\nrow.displayName AS x,\ncol.displayName AS y,\nrel.egress AS egress,\nrel.ingress AS ingress,\nrel.fromPort as fromPort,\nrel.toPort as toPort,\nrel.ipProtocol AS label"
					}
				]
			}
		},
		{
			id: "24aec314-7b12-4137-8f47-fe192000ea16",
			title: "Firewall Matrix - Internal",
			type: "matrix",
			config: {
				queries: [
					{
						name: "query1",
						query: "FIND Firewall AS row\nTHAT allows AS rel\nNetwork with public!=true' AS col\nRETURN\nrow.displayName AS x,\ncol.displayName AS y,\nrel.egress AS egress,\nrel.ingress AS ingress,\nrel.fromPort as fromPort,\nrel.toPort as toPort,\nrel.ipProtocol AS label"
					}
				]
			}
		}
	];
	var layouts$a = {
		sm: [
		],
		xs: [
		],
		lg: [
		],
		xl: [
		],
		md: [
		]
	};
	var firewallBoard = {
		widgets: widgets$a,
		layouts: layouts$a
	};

	var widgets$9 = [
		{
			id: "9389aa2f-bf6f-45b1-baae-ba9c0d1f60be",
			title: "Data stores in the US",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find DataStore with \n  region ~= ('us' or 'US') or \n  location ~= ('us' or 'US') or\n  zone ~= ('us' or 'US')\nreturn\n  DataStore._class as _class,\n  DataStore._type as _type,\n  DataStore.id as id,\n  DataStore.displayName as displayName,\n  DataStore.location as location, DataStore.region as region, DataStore.zone as zone, \n  DataStore.tag.AccountName as AccountName,\n  DataStore.classification as classification,\n  DataStore.owner as owner,\n  DataStore.createdOn as createdOn,\n  DataStore.public as public,\n  DataStore.encrypted as encrypted,\n  DataStore.webLink as webLink"
					},
					{
						name: "query2",
						query: "Find DataStore \nthat has (Service|Account) with \n  region ~= ('us' or 'US') or \n  location ~= ('us' or 'US') or\n  zone ~= ('us' or 'US') as e\nreturn\n  DataStore._class as _class,\n  DataStore._type as _type,\n  DataStore.id as id,\n  DataStore.displayName as displayName,\n  e.location as location, e.region as region, e.zone as zone, \n  DataStore.tag.AccountName as AccountName,\n  DataStore.classification as classification,\n  DataStore.owner as owner,\n  DataStore.createdOn as createdOn,\n  DataStore.public as public,\n  DataStore.encrypted as encrypted,\n  DataStore.webLink as webLink"
					}
				]
			}
		},
		{
			id: "628f924d-bd24-42a6-8ac0-5fd96596af82",
			title: "Data stores in the US",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find DataStore with \n  region ~= ('us' or 'US') or \n  location ~= ('us' or 'US') or \n  zone ~= ('us' or 'US')\nreturn count(DataStore) as value"
					},
					{
						name: "query2",
						query: "Find DataStore \nthat has (Service|Account) with \n  region ~= ('us' or 'US') or \n  location ~= ('us' or 'US') or \n  zone ~= ('us' or 'US')\nreturn count(DataStore) as value"
					}
				]
			}
		},
		{
			id: "1a555b9e-e05d-4d42-ac6f-016d89026527",
			title: "Data Stores in the EU",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find DataStore with \n  region ~= ('eu' or 'EU') or \n  location ~= ('eu' or 'EU') or\n  zone ~= ('eu' or 'EU')\nreturn count(DataStore) as value"
					},
					{
						name: "query2",
						query: "Find DataStore \nthat has (Service|Account) with \n  region ~= ('eu' or 'EU') or \n  location ~= ('eu' or 'EU') or\n  zone ~= ('eu' or 'EU')\nreturn count(DataStore) as value"
					}
				],
				settings: {
					number: {
						success: {
							limitCondition: "greaterThan",
							val1: 0
						}
					}
				}
			}
		},
		{
			id: "9b5037a5-e26c-4a05-b08c-db04a324c6cd",
			title: "Data Stores in the EU",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find DataStore with \n  region ~= ('eu' or 'EU') or \n  location ~= ('eu' or 'EU') or \n  zone ~= ('eu' or 'EU')\nreturn\n  DataStore._class as _class,\n  DataStore._type as _type,\n  DataStore.id as id,\n  DataStore.displayName as displayName,\n  DataStore.location as location, DataStore.region as region, DataStore.zone as zone, \n  DataStore.tag.AccountName as AccountName,\n  DataStore.classification as classification,\n  DataStore.owner as owner,\n  DataStore.createdOn as createdOn,\n  DataStore.public as public,\n  DataStore.encrypted as encrypted,\n  DataStore.webLink as webLink"
					},
					{
						name: "query2",
						query: "Find DataStore \nthat has (Service|Account) with\n  region ~= ('eu' or 'EU') or \n  location ~= ('eu' or 'EU') or\n  zone ~= ('eu' or 'EU') as e\nreturn\n  DataStore._class as _class,\n  DataStore._type as _type,\n  DataStore.id as id,\n  DataStore.displayName as displayName,\n  e.location as location, e.region as region, e.zone as zone, \n  DataStore.tag.AccountName as AccountName,\n  DataStore.classification as classification,\n  DataStore.owner as owner,\n  DataStore.createdOn as createdOn,\n  DataStore.public as public,\n  DataStore.encrypted as encrypted,\n  DataStore.webLink as webLink\n"
					}
				]
			}
		},
		{
			id: "f118da55-8852-4ea5-8c8f-a944f7a54f4c",
			title: "Non-EU/US Data Stores",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find DataStore with \n  (region !~= ('eu' or 'EU' or 'us' or 'US') and region != undefined) or\n  (location !~= ('eu' or 'EU' or 'us' or 'US') and location != undefined) or\n  (zone !~= ('eu' or 'EU' or 'us' or 'US') and zone != undefined) or\n  (region = undefined and location = undefined and zone = undefined)\nthat !has (Account|Service|Host) with \n  region ~= ('eu' and 'EU' and 'us' and 'US') or\n  location ~= ('eu' and 'EU' and 'us' and 'US') or \n  zone ~= ('eu' and 'EU' and 'us' and 'US')\nreturn count(DataStore) as value"
					}
				],
				settings: {
					number: {
						error: {
							limitCondition: "greaterThan",
							val1: 0
						}
					}
				}
			}
		},
		{
			id: "289a0ec4-27b4-44b2-8f66-6ce0cc3db001",
			title: "Non-EU/US Data Stored",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find DataStore with \n  (region !~= ('eu' or 'EU' or 'us' or 'US') and region != undefined) or\n  (location !~= ('eu' or 'EU' or 'us' or 'US') and location != undefined) or\n  (zone !~= ('eu' or 'EU' or 'us' or 'US') and zone != undefined) or\n  (region = undefined and location = undefined and zone = undefined)\nthat !has (Account|Service|Host) with \n  region ~= ('eu' and 'EU' and 'us' and 'US') or\n  location ~= ('eu' and 'EU' and 'us' and 'US') or\n  zone ~= ('eu' and 'EU' and 'us' and 'US')\nreturn\n  DataStore._class as _class,\n  DataStore._type as _type,\n  DataStore.id as id,\n  DataStore.displayName as displayName,\n  DataStore.location as location, DataStore.region as region, DataStore.zone as zone, \n  DataStore.tag.AccountName as AccountName,\n  DataStore.classification as classification,\n  DataStore.owner as owner,\n  DataStore.createdOn as createdOn,\n  DataStore.public as public,\n  DataStore.encrypted as encrypted,\n  DataStore.webLink as webLink"
					}
				]
			}
		}
	];
	var layouts$9 = {
		sm: [
		],
		xs: [
			{
				"static": false,
				w: 1,
				moved: false,
				h: 2,
				x: 0,
				y: 0,
				i: "9389aa2f-bf6f-45b1-baae-ba9c0d1f60be"
			},
			{
				"static": false,
				w: 1,
				moved: false,
				h: 2,
				x: 0,
				y: 2,
				i: "628f924d-bd24-42a6-8ac0-5fd96596af82"
			},
			{
				"static": false,
				w: 1,
				moved: false,
				h: 2,
				x: 0,
				y: 4,
				i: "1a555b9e-e05d-4d42-ac6f-016d89026527"
			}
		],
		lg: [
			{
				"static": false,
				w: 9,
				moved: false,
				h: 3,
				x: 3,
				y: 3,
				i: "9389aa2f-bf6f-45b1-baae-ba9c0d1f60be"
			},
			{
				"static": false,
				w: 3,
				moved: false,
				h: 3,
				x: 0,
				y: 3,
				i: "628f924d-bd24-42a6-8ac0-5fd96596af82"
			},
			{
				"static": false,
				w: 3,
				moved: false,
				h: 3,
				x: 0,
				y: 0,
				i: "1a555b9e-e05d-4d42-ac6f-016d89026527"
			},
			{
				"static": false,
				w: 9,
				moved: false,
				h: 3,
				x: 3,
				y: 0,
				i: "9b5037a5-e26c-4a05-b08c-db04a324c6cd"
			},
			{
				"static": false,
				w: 3,
				moved: false,
				h: 3,
				x: 0,
				y: 6,
				i: "f118da55-8852-4ea5-8c8f-a944f7a54f4c"
			},
			{
				"static": false,
				w: 9,
				moved: false,
				h: 3,
				x: 3,
				y: 6,
				i: "289a0ec4-27b4-44b2-8f66-6ce0cc3db001"
			}
		],
		xl: [
		],
		md: [
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 0,
				i: "9389aa2f-bf6f-45b1-baae-ba9c0d1f60be"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 2,
				i: "628f924d-bd24-42a6-8ac0-5fd96596af82"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 4,
				i: "1a555b9e-e05d-4d42-ac6f-016d89026527"
			}
		]
	};
	var gdprDataLocationsBoard = {
		widgets: widgets$9,
		layouts: layouts$9
	};

	var widgets$8 = [
		{
			id: "9955cba1-0504-4002-b403-cdc434f9f2a8",
			title: "Production  hosts with medium or higher vulnerability findings",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find Host with tag.Production=true that has Finding with numericSeverity>=5\nreturn \n  Host._type, \n  Host.tag.AccountName as account, \n  Host.displayName as name, \n  Host.fqdn as fqdn, \n  Host.publicIpAddress as publicIp, \n  Host.privateIpAddress as privateIp\norder by Host.tag.AccountName"
					}
				]
			}
		},
		{
			id: "a0f92563-6265-4ae7-8e95-d1c3381f0805",
			title: "Internet-facing hosts with medium or higher vulnerability findings",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find Internet that allows Firewall \n  that protects Host with tag.Production=true that has Finding with numericSeverity>=5\nreturn \n  Host._type, \n  Host.tag.AccountName as account, \n  Host.displayName as name, \n  Host.fqdn as fqdn, \n  Host.publicIpAddress as publicIp, \n  Host.privateIpAddress as privateIp\norder by Host.tag.AccountName"
					}
				]
			}
		},
		{
			id: "30b80a8a-a4f6-45c8-873d-93e4db8f5476",
			title: "Non-public data stores with public access",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find DataStore with classification != 'public'\n  that allows AccessPolicy\n  that assigned AccessRole\n  that (assigned|trusts|uses) Host\n  that protects Firewall\n  that allows Internet\nreturn \n  DataStore._type, DataStore.name, DataStore.tag.AccountName, \n  DataStore.encrypted, DataStore.classification"
					},
					{
						name: "query2",
						query: "Find DataStore \n  with classification != 'public' and ignorePublicAcls != true and restrictPublicBuckets != true\nthat ALLOWS as grant Everyone\nreturn \n  DataStore._type, DataStore.name, DataStore.tag.AccountName, \n  DataStore.encrypted, DataStore.classification,\n  grant.permission"
					}
				]
			}
		},
		{
			id: "73a3849a-69d6-4ea0-9291-0fd663e7518a",
			title: "Publicly accessible databases",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find Database with public=true \n  that protects Firewall \n  that allows as rule Internet\nreturn \n  Database._type, Database.name, Database.tag.AccountName, \n  rule.ipProtocol, rule.ingress, rule.egress, rule.fromPort, rule.toPort"
					}
				]
			}
		},
		{
			id: "ae9f4ef8-f761-485f-9c72-4f86b2c6e86e",
			title: "Public data store containing sensitive data",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find Finding with hasSensitiveData=true and open!=false\nthat has DataStore \n  with ignorePublicAcls != true and restrictPublicBuckets != true\nthat ALLOWS as grant Everyone\nreturn\n  DataStore._type, DataStore.name, DataStore.tag.AccountName,\n  Finding._type, Finding.displayName, Finding.file, Finding.PII, Finding.PCI, Finding.secret"
					},
					{
						name: "query2",
						query: "Find Finding with hasSensitiveData=true and open!=false\n  that has DataStore\n  that allows AccessPolicy\n  that assigned AccessRole\n  that (assigned|trusts|uses) Host\n  that protects Firewall\n  that allows Internet\nreturn\n  DataStore._type, DataStore.name, DataStore.tag.AccountName,\n  Finding._type, Finding.displayName, Finding.file, Finding.PII, Finding.PCI, Finding.secret"
					}
				]
			}
		},
		{
			id: "a55cb673-0699-4ebe-a9da-6925effd9767",
			title: "Vulnerable Workloads with Access to Critical Data",
			type: "graph",
			config: {
				queries: [
					{
						name: "query1",
						query: "find Finding \nthat has (Host|Function|Container) \nthat uses DataStore with classification='critical'\nreturn TREE"
					}
				]
			}
		},
		{
			id: "e00af8a4-57e2-4dcb-bed0-355d08386c6f",
			title: "Vulnerable Production Assets being Probed",
			type: "graph",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find Finding with category='event' and open=true \nthat has (Host|Function|Container) as i \nthat has Finding with category!='event' and numericSeverity > 5 and open=true\nreturn TREE"
					}
				]
			}
		}
	];
	var layouts$8 = {
		sm: [
		],
		xs: [
		],
		lg: [
			{
				w: 6,
				h: 2,
				x: 0,
				y: 0,
				i: "9955cba1-0504-4002-b403-cdc434f9f2a8",
				moved: false,
				"static": false
			},
			{
				w: 6,
				h: 2,
				x: 6,
				y: 0,
				i: "a0f92563-6265-4ae7-8e95-d1c3381f0805",
				moved: false,
				"static": false
			},
			{
				w: 12,
				h: 2,
				x: 0,
				y: 6,
				i: "30b80a8a-a4f6-45c8-873d-93e4db8f5476",
				moved: false,
				"static": false
			},
			{
				w: 12,
				h: 2,
				x: 0,
				y: 10,
				i: "73a3849a-69d6-4ea0-9291-0fd663e7518a",
				moved: false,
				"static": false
			},
			{
				w: 12,
				h: 2,
				x: 0,
				y: 8,
				i: "ae9f4ef8-f761-485f-9c72-4f86b2c6e86e",
				moved: false,
				"static": false
			},
			{
				w: 6,
				h: 4,
				x: 0,
				y: 2,
				i: "a55cb673-0699-4ebe-a9da-6925effd9767",
				moved: false,
				"static": false
			},
			{
				w: 6,
				h: 4,
				x: 6,
				y: 2,
				i: "e00af8a4-57e2-4dcb-bed0-355d08386c6f",
				moved: false,
				"static": false
			}
		],
		xl: [
		],
		md: [
		]
	};
	var highRiskAssetsBoard = {
		widgets: widgets$8,
		layouts: layouts$8
	};

	var widgets$7 = [
		{
			id: "5b9f79e7-e7ab-4c3f-8e94-516e0b78fe3b",
			title: "Classification by Resource Type",
			type: "matrix",
			config: {
				queries: [
					{
						name: "query1",
						query: "FIND (DataStore|Host) as ds\nRETURN\n  ds.classification AS x,\n  ds._type AS y,\n  count(ds) as resources"
					}
				]
			}
		},
		{
			id: "93c2be60-a2ef-4681-8ec6-592b6615b5d7",
			title: "Resource Classification",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "FIND (DataStore|Host) as ds\nRETURN\n  ds.classification AS name,\n  count(ds) as value"
					}
				]
			}
		},
		{
			id: "d25a7181-473b-4b24-a930-6b32b927bb68",
			title: "Classification by Account",
			type: "matrix",
			config: {
				queries: [
					{
						name: "query1",
						query: "FIND (DataStore|Host) as ds\nRETURN\n  ds.classification AS x,\n  ds.tag.AccountName AS y,\n  count(ds) as resources"
					}
				]
			}
		},
		{
			id: "875c07ac-d035-4b98-a5d1-98ee4acd24f7",
			title: "Unclassified Hosts in Production",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find Host with classification = undefined and tag.Production=true\nreturn count(Host) as value"
					}
				],
				settings: {
					number: {
						warning: {
							limitCondition: "greaterThan",
							val1: 0
						}
					}
				}
			}
		},
		{
			id: "2f64e013-03e0-41b5-8281-d22a12683952",
			title: "Unclassified Data Stores in Production",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find DataStore with classification = undefined and tag.Production=true\nreturn count(DataStore) as value"
					}
				],
				settings: {
					number: {
						warning: {
							limitCondition: "greaterThan",
							val1: 0
						}
					}
				}
			}
		},
		{
			id: "841686ed-d0d4-46e1-85b6-1bbbc528e884",
			title: "Unclassified Hosts in Production",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find Host with classification = undefined and tag.Production=true"
					}
				]
			}
		},
		{
			id: "4ba80551-fb57-4047-83f2-c36653f696d2",
			title: "Unclassified Data Stores in Production",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find DataStore with classification = undefined and tag.Production=true\n"
					}
				]
			}
		}
	];
	var layouts$7 = {
		sm: [
			{
				x: 0,
				h: 2,
				i: "5b9f79e7-e7ab-4c3f-8e94-516e0b78fe3b",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "93c2be60-a2ef-4681-8ec6-592b6615b5d7",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "d25a7181-473b-4b24-a930-6b32b927bb68",
				y: 1000000000000,
				w: 2
			}
		],
		xs: [
		],
		lg: [
			{
				"static": false,
				w: 5,
				moved: false,
				h: 3,
				x: 3,
				y: 0,
				i: "5b9f79e7-e7ab-4c3f-8e94-516e0b78fe3b"
			},
			{
				"static": false,
				w: 3,
				moved: false,
				h: 3,
				x: 0,
				y: 0,
				i: "93c2be60-a2ef-4681-8ec6-592b6615b5d7"
			},
			{
				"static": false,
				w: 4,
				moved: false,
				h: 3,
				x: 8,
				y: 0,
				i: "d25a7181-473b-4b24-a930-6b32b927bb68"
			},
			{
				"static": false,
				w: 3,
				moved: false,
				h: 3,
				x: 0,
				y: 3,
				i: "875c07ac-d035-4b98-a5d1-98ee4acd24f7"
			},
			{
				"static": false,
				w: 3,
				moved: false,
				h: 3,
				x: 0,
				y: 6,
				i: "2f64e013-03e0-41b5-8281-d22a12683952"
			},
			{
				"static": false,
				w: 9,
				moved: false,
				h: 3,
				x: 3,
				y: 3,
				i: "841686ed-d0d4-46e1-85b6-1bbbc528e884"
			},
			{
				"static": false,
				w: 9,
				moved: false,
				h: 3,
				x: 3,
				y: 6,
				i: "4ba80551-fb57-4047-83f2-c36653f696d2"
			}
		],
		xl: [
		],
		md: [
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 0,
				i: "5b9f79e7-e7ab-4c3f-8e94-516e0b78fe3b"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 2,
				i: "93c2be60-a2ef-4681-8ec6-592b6615b5d7"
			},
			{
				"static": false,
				w: 6,
				moved: false,
				h: 2,
				x: 0,
				y: 4,
				i: "d25a7181-473b-4b24-a930-6b32b927bb68"
			}
		]
	};
	var resourceClassificationBoard = {
		widgets: widgets$7,
		layouts: layouts$7
	};

	var widgets$6 = [
		{
			id: "b0eb0585-aa7b-4a3d-9eac-34189d7f1e0d",
			title: "Open Risks",
			type: "number",
			config: {
				queries: [
					{
						name: "query0",
						query: "Find Risk with open=true as r\nreturn count(r) as value"
					}
				],
				settings: {
					number: {
						error: {
							val1: "3"
						},
						warning: {
							limitCondition: "greaterThan",
							val1: "0"
						}
					}
				}
			}
		},
		{
			id: "fad00736-46b4-4401-9b7d-dc37cab1a359",
			title: "Accepted Risk",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find Risk with \n    status=('accepted' or 'Accepted' or 'transfered' or 'Transfered') as r\nreturn count(r) as value"
					}
				]
			}
		},
		{
			id: "281975be-11c9-40c5-8f65-c2c9b2d37c0f",
			title: "Mitigated Risk",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find Risk with status=('mitigated' or 'Mitigated') as r\nreturn count(r) as value"
					}
				],
				settings: {
					number: {
						success: {
							limitCondition: "greaterThan",
							val1: "0"
						}
					}
				}
			}
		},
		{
			id: "95c6cd8b-2519-4c74-9cc2-674b0075d894",
			title: "Risks Open >1yr",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find Risk with \n  open=true and (updatedOn < date.now-1yr or \n  (updatedOn = undefined and createdOn < date.now-1yr)) as r\nreturn count(r) as value"
					}
				],
				settings: {
					number: {
						error: {
							limitCondition: "greaterThan",
							val1: "0"
						}
					}
				}
			}
		},
		{
			id: "0e8a01c4-cf06-4b3f-beeb-1966a43d4e2d",
			title: "Open Risks",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "FIND Risk WITH open = true RETURN Risk.name, Risk.description, Risk.probability, Risk.impact, Risk.level, Risk.assignee, Risk.webLink"
					}
				]
			}
		}
	];
	var layouts$6 = {
		sm: [
		],
		xs: [
		],
		lg: [
			{
				"static": false,
				w: 3,
				moved: false,
				h: 2,
				x: 0,
				y: 0,
				i: "b0eb0585-aa7b-4a3d-9eac-34189d7f1e0d"
			},
			{
				"static": false,
				w: 3,
				moved: false,
				h: 2,
				x: 9,
				y: 0,
				i: "fad00736-46b4-4401-9b7d-dc37cab1a359"
			},
			{
				"static": false,
				w: 3,
				moved: false,
				h: 2,
				x: 6,
				y: 0,
				i: "281975be-11c9-40c5-8f65-c2c9b2d37c0f"
			},
			{
				"static": false,
				w: 3,
				moved: false,
				h: 2,
				x: 3,
				y: 0,
				i: "95c6cd8b-2519-4c74-9cc2-674b0075d894"
			},
			{
				"static": false,
				w: 12,
				moved: false,
				h: 3,
				x: 0,
				y: 2,
				i: "0e8a01c4-cf06-4b3f-beeb-1966a43d4e2d"
			}
		],
		xl: [
		],
		md: [
		]
	};
	var riskRegisterBoard = {
		widgets: widgets$6,
		layouts: layouts$6
	};

	var widgets$5 = [
		{
			id: "48653818-85b9-41e7-b616-08adcbad95e3",
			title: "Total number of Employees",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find employee as e return count(e) as value"
					}
				]
			}
		},
		{
			id: "b9f9e029-d877-450e-9877-ff6036aab129",
			title: "Employees added last 30 days",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find employee with _createdOn >= date.now - 30days as e return count(e) as value"
					}
				],
				settings: {
					number: {
						success: {
							limitCondition: "greaterThan",
							val1: 0
						}
					}
				}
			}
		},
		{
			id: "f0c893b5-80b2-4ff3-89ae-ff73ff580eb3",
			title: "Employees added last 60 days",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find employee with _createdOn >= date.now - 60days as e return count(e) as value"
					}
				],
				settings: {
					number: {
						success: {
							limitCondition: "greaterThan",
							val1: 0
						}
					}
				}
			}
		},
		{
			id: "226b57f0-287c-4faf-9066-ed0337aeacf2",
			title: "Employees added last 90 days",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find employee with _createdOn >= date.now - 90days as e return count(e) as value"
					}
				],
				settings: {
					number: {
						success: {
							limitCondition: "greaterThan",
							val1: 0
						}
					}
				}
			}
		}
	];
	var layouts$5 = {
		xs: [
		],
		sm: [
		],
		md: [
			{
				w: 6,
				h: 2,
				x: 0,
				y: 0,
				i: "48653818-85b9-41e7-b616-08adcbad95e3",
				moved: false,
				"static": false
			},
			{
				w: 6,
				h: 2,
				x: 0,
				y: 2,
				i: "b9f9e029-d877-450e-9877-ff6036aab129",
				moved: false,
				"static": false
			},
			{
				w: 6,
				h: 2,
				x: 0,
				y: 4,
				i: "f0c893b5-80b2-4ff3-89ae-ff73ff580eb3",
				moved: false,
				"static": false
			},
			{
				w: 6,
				h: 2,
				x: 0,
				y: 6,
				i: "226b57f0-287c-4faf-9066-ed0337aeacf2",
				moved: false,
				"static": false
			}
		],
		lg: [
			{
				w: 4,
				h: 4,
				x: 0,
				y: 0,
				i: "48653818-85b9-41e7-b616-08adcbad95e3",
				moved: false,
				"static": false
			},
			{
				w: 8,
				h: 2,
				x: 4,
				y: 0,
				i: "b9f9e029-d877-450e-9877-ff6036aab129",
				moved: false,
				"static": false
			},
			{
				w: 4,
				h: 2,
				x: 4,
				y: 2,
				i: "f0c893b5-80b2-4ff3-89ae-ff73ff580eb3",
				moved: false,
				"static": false
			},
			{
				w: 4,
				h: 2,
				x: 8,
				y: 2,
				i: "226b57f0-287c-4faf-9066-ed0337aeacf2",
				moved: false,
				"static": false
			}
		],
		xl: [
		]
	};
	var teamGrowthBoard = {
		widgets: widgets$5,
		layouts: layouts$5
	};

	var widgets$4 = [
		{
			id: "4efc35e2-2ac3-4f0f-a057-3e16601b39e5",
			title: "Number of Users by Account",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find User as u\nReturn\n  u.tag.AccountName as name,\n  count(u) as value"
					}
				]
			}
		},
		{
			id: "7c18aac8-92b9-4efb-ab92-466c86e5645f",
			title: "System/Shared/External/Unmapped user accounts",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find User as u that !is Person\n  return u.tag.AccountName, u._type, u.displayName, u.username, u.email\n  order by u.tag.AccountName"
					}
				]
			}
		},
		{
			id: "fa03f51a-da6e-41b1-ba94-1144b37949e0",
			title: "Admin Users",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find User with admin=true \nReturn User.tag.AccountName as Account, \n  User._type, User.displayName, User.email"
					},
					{
						name: "query2",
						query: "Find User that ASSIGNED AccessRole that ASSIGNED AccessPolicy with admin = true\nReturn AccessRole.tag.AccountName as Account, \n  User._type, User.displayName, User.email"
					}
				]
			}
		}
	];
	var layouts$4 = {
		sm: [
		],
		xs: [
		],
		lg: [
			{
				"static": false,
				w: 4,
				moved: false,
				h: 6,
				x: 0,
				y: 0,
				i: "4efc35e2-2ac3-4f0f-a057-3e16601b39e5"
			},
			{
				"static": false,
				w: 8,
				moved: false,
				h: 3,
				x: 4,
				y: 3,
				i: "7c18aac8-92b9-4efb-ab92-466c86e5645f"
			},
			{
				"static": false,
				w: 8,
				moved: false,
				h: 3,
				x: 4,
				y: 0,
				i: "fa03f51a-da6e-41b1-ba94-1144b37949e0"
			}
		],
		xl: [
		],
		md: [
		]
	};
	var userAccessBoard = {
		widgets: widgets$4,
		layouts: layouts$4
	};

	var widgets$3 = [
		{
			id: "27a9f964-ec4a-4dd9-911d-9e99ee5cdfd5",
			title: "Endpoint agent protection status",
			type: "pie",
			config: {
				queries: [
					{
						name: "query0",
						query: "Find HostAgent with active=true as agent\n  that (monitors|manages|protects) (Host|Device)\nreturn\n  agent.active as name,\n  count(agent) as value"
					},
					{
						name: "query1",
						query: "Find HostAgent with active=false as agent\n  that (monitors|manages|protects) (Host|Device)\nreturn\n  agent.active as name,\n  count(agent) as value"
					},
					{
						name: "query2",
						query: "Find HostAgent with active=undefined as agent\n  that (monitors|manages|protects) (Host|Device)\nreturn\n  agent.active as name,\n  count(agent) as value"
					}
				]
			}
		},
		{
			id: "29263916-6b14-42b2-82d6-d7468920c685",
			title: "Number of users without an assigned device",
			type: "number",
			config: {
				queries: [
					{
						name: "query0",
						query: "Find Person as p that !owns Device return count(p) as value"
					}
				]
			}
		},
		{
			id: "311eb5b3-f2b5-4227-b2d2-18549dfc0b82",
			title: "User Devices by Location",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find HostAgent as agent\n  that (monitors|manages|protects) (Host|Device)\nreturn\n  agent.lastLocation as name,\n  count(agent) as value"
					}
				]
			}
		},
		{
			id: "8e97ea26-0669-49f7-8937-19febc8ebf9a",
			title: "User Devices by OS",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find user_endpoint as d\nreturn\n  d.osName as name,\n  count(d) as value"
					}
				]
			}
		},
		{
			id: "99dd8dff-4134-46c4-8f0e-3b7dcbfd07b5",
			title: "Devices not seen for >7 days",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find HostAgent with lastReportedTime < date.now - 7days as d\n  that (monitors|manages|protects) (Host|Device)\nReturn \n  d.displayName as device, \n  d.lastReportedTime as lastSeenOn, \n  d.email as owner"
					}
				]
			}
		},
		{
			id: "31a80290-8d25-4705-8220-10861191c527",
			title: "User Devices by OS and Version",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find user_endpoint as d\nreturn\n  d.osName as osName,\n  d.osVersion as osVersion,\n  count(d) as deviceCount"
					}
				]
			}
		},
		{
			id: "ba81c0e4-e425-4666-a78e-09fa7aaf5ef0",
			title: "Endpoint Encryption Status",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find user_endpoint as d\nreturn d.encrypted as name, count(d) as value"
					}
				]
			}
		}
	];
	var layouts$3 = {
		sm: [
		],
		xs: [
		],
		lg: [
			{
				"static": false,
				w: 4,
				moved: false,
				h: 2,
				x: 4,
				y: 4,
				i: "27a9f964-ec4a-4dd9-911d-9e99ee5cdfd5"
			},
			{
				"static": false,
				w: 4,
				moved: false,
				h: 2,
				x: 0,
				y: 0,
				i: "29263916-6b14-42b2-82d6-d7468920c685"
			},
			{
				"static": false,
				w: 4,
				moved: false,
				h: 2,
				x: 0,
				y: 4,
				i: "311eb5b3-f2b5-4227-b2d2-18549dfc0b82"
			},
			{
				"static": false,
				w: 4,
				moved: false,
				h: 2,
				x: 0,
				y: 2,
				i: "8e97ea26-0669-49f7-8937-19febc8ebf9a"
			},
			{
				"static": false,
				w: 8,
				moved: false,
				h: 2,
				x: 4,
				y: 0,
				i: "99dd8dff-4134-46c4-8f0e-3b7dcbfd07b5"
			},
			{
				"static": false,
				w: 8,
				moved: false,
				h: 2,
				x: 4,
				y: 2,
				i: "31a80290-8d25-4705-8220-10861191c527"
			},
			{
				"static": false,
				w: 4,
				moved: false,
				h: 2,
				x: 8,
				y: 4,
				i: "ba81c0e4-e425-4666-a78e-09fa7aaf5ef0"
			}
		],
		xl: [
		],
		md: [
		]
	};
	var userEndpointsBoard = {
		widgets: widgets$3,
		layouts: layouts$3
	};

	var widgets$2 = [
		{
			id: "6ad084c9-685f-4ff4-9f16-60eada53abaf",
			title: "Users have incomplete training",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find unique Training as t \nthat assigned as enrollment User as u \nwhere enrollment.completedOn = undefined \nreturn t.displayName as name, count(u) as value"
					}
				]
			}
		},
		{
			id: "b850107e-1fef-4a38-9ee0-18bc1d76ca10",
			title: "Users completed assigned training",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find Training as t \nthat assigned as enrollment User as u \nwhere enrollment.completedOn != undefined \nreturn t.displayName as name, count(u) as value"
					}
				]
			}
		},
		{
			id: "41a2bc5f-fd73-4d7c-b9a3-de283a9a860c",
			title: "Users have not completed assigned training",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find unique Training as t \nthat assigned as enrollment User as u \nwhere enrollment.completedOn = undefined \nreturn u.displayName, u.email, t.displayName"
					}
				]
			}
		},
		{
			id: "7d9249f1-5989-4936-9c00-c60425f9de4c",
			title: "Assigned Security Awareness Trainings",
			type: "table",
			config: {
				queries: [
					{
						name: "query 1",
						query: "Find training_campaign as c that HAS training_module as m that ASSIGNED \nUser as u return m.displayName as Training, c.completionPercentage as percentComplete, count(u) as assignedUsers"
					}
				]
			}
		}
	];
	var layouts$2 = {
		sm: [
		],
		xs: [
		],
		lg: [
			{
				x: 0,
				h: 2,
				i: "6ad084c9-685f-4ff4-9f16-60eada53abaf",
				y: 0,
				w: 6
			},
			{
				x: 6,
				h: 2,
				i: "b850107e-1fef-4a38-9ee0-18bc1d76ca10",
				y: 0,
				w: 6
			},
			{
				x: 0,
				h: 2,
				i: "41a2bc5f-fd73-4d7c-b9a3-de283a9a860c",
				y: 2,
				w: 12
			}
		],
		xl: [
		],
		md: [
		]
	};
	var userTrainingBoard = {
		widgets: widgets$2,
		layouts: layouts$2
	};

	var widgets$1 = [
		{
			id: "c5619a89-456c-41b5-b0aa-543867cc8d08",
			title: "Top OAuth Users",
			type: "bar",
			config: {
				queries: [
					{
						name: "Vendors",
						query: "find Vendor as v that allows AccessKey that assigned User as u return u.name as x, count(v) as y order by y desc limit 8"
					}
				]
			}
		},
		{
			id: "b1fdd971-5744-4f8a-baed-cc3b2c7fd573",
			title: "Total Vendors",
			type: "number",
			config: {
				queries: [
					{
						name: "Vendors",
						query: "Find Vendor as v return count(v) as value"
					}
				],
				settings: {
					number: {
						"default": {
							limitCondition: "lessThan",
							val1: 10
						},
						success: {
							limitCondition: "between",
							val1: 10,
							val2: 35
						},
						warning: {
							limitCondition: "between",
							val1: 36,
							val2: 75
						},
						error: {
							limitCondition: "greaterThan",
							val1: 75
						}
					}
				}
			}
		},
		{
			id: "dbb9e611-2a11-4bbd-8e2f-d49eea6ef4ee",
			title: "Unvalidated Vendors",
			type: "number",
			config: {
				queries: [
					{
						name: "Vendors",
						query: "Find Vendor with validated=false as v return count(v) as value"
					}
				],
				settings: {
					number: {
						"default": {
							limitCondition: "lessThanOrEqualTo",
							val1: 3
						},
						success: {
							limitCondition: "between",
							val1: 4,
							val2: 8
						},
						warning: {
							limitCondition: "between",
							val1: 9,
							val2: 15
						},
						error: {
							limitCondition: "greaterThanOrEqualTo",
							val1: 16
						}
					}
				}
			}
		},
		{
			id: "a70dfab7-ecd7-454a-a220-f5ee1f29c0ca",
			title: "Top 20 OAuth Apps by Usage",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "find Vendor as v that allows AccessKey that assigned User as u return v.name as name, count(u) as value ORDER by value DESC LIMIT 20"
					}
				]
			}
		},
		{
			id: "a51c1a02-d687-4ddc-b142-de002ad187a4",
			title: "Unvalidated Vendors",
			type: "table",
			config: {
				queries: [
					{
						name: "Vendors",
						query: "Find Vendor with validated=false ORDER by Vendor._createdOn DESC"
					}
				]
			}
		}
	];
	var layouts$1 = {
		sm: [
		],
		xs: [
		],
		lg: [
			{
				w: 12,
				h: 2,
				x: 0,
				y: 2,
				i: "c5619a89-456c-41b5-b0aa-543867cc8d08",
				moved: false,
				"static": false
			},
			{
				w: 2,
				h: 2,
				x: 0,
				y: 0,
				i: "b1fdd971-5744-4f8a-baed-cc3b2c7fd573",
				moved: false,
				"static": false
			},
			{
				w: 2,
				h: 2,
				x: 2,
				y: 0,
				i: "dbb9e611-2a11-4bbd-8e2f-d49eea6ef4ee",
				moved: false,
				"static": false
			},
			{
				w: 8,
				h: 2,
				x: 4,
				y: 0,
				i: "a70dfab7-ecd7-454a-a220-f5ee1f29c0ca",
				moved: false,
				"static": false
			},
			{
				w: 12,
				h: 3,
				x: 0,
				y: 4,
				i: "a51c1a02-d687-4ddc-b142-de002ad187a4",
				moved: false,
				"static": false
			}
		],
		xl: [
		],
		md: [
		]
	};
	var vendorMgmtBoard = {
		widgets: widgets$1,
		layouts: layouts$1
	};

	var widgets = [
		{
			id: "349fc061-44dd-4ef4-bad0-e474d23c621e",
			title: "Opening Vuln Findings by Severity",
			type: "bar",
			config: {
				queries: [
					{
						name: "query0",
						query: "Find (Vulnerability|Finding) with open=true as v\nreturn\n  v.severity as x,\n  count(v) as y"
					}
				]
			}
		},
		{
			id: "f56853dc-aace-4e9b-8e79-561deb4736e3",
			title: "Threats by Attack Source (GuardDuty)",
			type: "pie",
			config: {
				queries: [
					{
						name: "attackSource",
						query: "Find aws_guardduty_finding as f\n  return f.attackSource as name, count(f) as value"
					},
					{
						name: "undefined",
						query: "Find aws_guardduty_finding with attackSource=undefined as f\n  return f.tag.AccountName as name, count(f) as value"
					}
				]
			}
		},
		{
			id: "5754519b-a4a1-4360-8737-4124976be4fe",
			title: "Threats by Attack Target (GuardDuty)",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find aws_guardduty_finding as f\n  return f.targets as name, count(f) as value\n  order by value desc limit 25"
					}
				]
			}
		},
		{
			id: "0b6ec497-5270-479e-8873-a836b5e0e451",
			title: "Threats by Attack Target Type",
			type: "pie",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find (Application|Host|Project|CodeRepo) as t that has Finding as f\n  return t._type as name, count(f) as value"
					}
				]
			}
		},
		{
			id: "6a90569c-1161-4f88-a35f-a83815195318",
			title: "Top 10 CWEs",
			type: "bar",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find (Vulnerability|Finding) as v that exploits cwe as w\n  return w.displayName as x, count(v) as y order by y desc limit 10"
					}
				]
			}
		},
		{
			id: "3f9c8980-5dc5-485c-85fc-0ac0b650832f",
			title: "Open Findings by Type",
			type: "pie",
			config: {
				queries: [
					{
						name: "query0",
						query: "Find Finding with open!=false as f \n  return f._type as name, count(f) as value"
					}
				]
			}
		},
		{
			id: "7867906b-8927-46cf-b3ad-811f89b13c42",
			title: "Top 10 CVEs",
			type: "bar",
			config: {
				queries: [
					{
						name: "query0",
						query: "Find cve as cve that (HAS|IS) * as f\n  return cve.displayName as x, count(f) as y order by y desc limit 10"
					}
				]
			}
		},
		{
			id: "b53577bc-1f22-4aa0-9fb6-20fb23f321bf",
			title: "AWS EC2 Instance Vuln Findings by Account",
			type: "pie",
			config: {
				queries: [
					{
						name: "query0",
						query: "Find aws_instance as i that has Finding as f\nreturn i.tag.AccountName as name, count(f) as value"
					}
				]
			}
		},
		{
			id: "39d3073a-7387-4b5a-847d-657540025daa",
			title: "Code Vuln Findings by App/Project",
			type: "pie",
			config: {
				queries: [
					{
						name: "query0",
						query: "Find (Application|Product|Project|Account) as a\n  that (has|owns) CodeRepo as c\n  that has (Vulnerability|Finding) as f\nreturn a.displayName as name, count(f) as value"
					}
				]
			}
		},
		{
			id: "5ed8ee84-229f-488d-8742-5a555396354f",
			title: "Open Security Tickets",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find Record with displayName ^= 'SEC' and (active=true or open=true) as i \nreturn count(i) as value"
					}
				]
			}
		},
		{
			id: "0d062bfd-7cc9-4021-a2d2-cfe9a81f8bf1",
			title: "Open AppSec Tickets",
			type: "table",
			config: {
				queries: [
					{
						name: "query1",
						query: "Find Record with displayName ^= 'SEC-' and labels = 'ProdSec' and (open=true or active=true) as i \nRETURN i.displayName as Ticket, i.summary as Summary, i.priority as Priority, i.status as Status"
					}
				]
			}
		},
		{
			id: "f6ad2d37-9f9e-4c8d-8d3a-1be55c951e06",
			title: "Production workloads at risk",
			type: "graph",
			config: {
				queries: [
					{
						name: "query1",
						query: "find (Host|Function|Container) with tag.Production=true\n(that uses Image)?\nthat has Finding\nreturn tree"
					}
				]
			}
		},
		{
			id: "91fd7c54-0b38-4f1e-b8c7-92ae0dcd8406",
			title: "Vulnerability Findings on Production Workloads ",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "find (Host|Function|Container) with tag.Production=true as i\n(that uses Image)?\nthat has Finding as f\nreturn count(f) as value"
					}
				],
				settings: {
					number: {
						error: {
							limitCondition: "greaterThan",
							val1: 0
						}
					}
				}
			}
		},
		{
			id: "376685a3-d45a-4fb4-a5a3-57b78ad9e83f",
			title: "Vulnerability Findings on Production Applications",
			type: "number",
			config: {
				queries: [
					{
						name: "query1",
						query: "find Finding as f\nthat has CodeRepo \nthat (Defines|Deployed) (Function|Host|Container) with tag.Production=true\nreturn count(f) as value"
					}
				],
				settings: {
					number: {
						error: {
							limitCondition: "greaterThan",
							val1: 0
						}
					}
				}
			}
		},
		{
			id: "35e36b5d-5b71-4381-bcaa-137e2813f338",
			title: "Production Applications At Risk",
			type: "graph",
			config: {
				queries: [
					{
						name: "query1",
						query: "find Finding \nthat has CodeRepo \nthat (Defines|Deployed) (Function|Host|Container) with tag.Production=true\nreturn TREE"
					}
				]
			}
		}
	];
	var layouts = {
		sm: [
			{
				x: 0,
				h: 2,
				i: "349fc061-44dd-4ef4-bad0-e474d23c621e",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "f56853dc-aace-4e9b-8e79-561deb4736e3",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "5754519b-a4a1-4360-8737-4124976be4fe",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "0b6ec497-5270-479e-8873-a836b5e0e451",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "6a90569c-1161-4f88-a35f-a83815195318",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "3f9c8980-5dc5-485c-85fc-0ac0b650832f",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "7867906b-8927-46cf-b3ad-811f89b13c42",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "b53577bc-1f22-4aa0-9fb6-20fb23f321bf",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "39d3073a-7387-4b5a-847d-657540025daa",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "5ed8ee84-229f-488d-8742-5a555396354f",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "0d062bfd-7cc9-4021-a2d2-cfe9a81f8bf1",
				y: 1000000000000,
				w: 2
			},
			{
				x: 0,
				h: 2,
				i: "70ffd883-b92f-4b16-85cd-162b8d31daef",
				y: 1000000000000,
				w: 2
			}
		],
		xs: [
		],
		lg: [
			{
				w: 6,
				h: 3,
				x: 6,
				y: 0,
				i: "349fc061-44dd-4ef4-bad0-e474d23c621e",
				moved: false,
				"static": false
			},
			{
				w: 6,
				h: 2,
				x: 0,
				y: 16,
				i: "f56853dc-aace-4e9b-8e79-561deb4736e3",
				moved: false,
				"static": false
			},
			{
				w: 4,
				h: 3,
				x: 0,
				y: 9,
				i: "5754519b-a4a1-4360-8737-4124976be4fe",
				moved: false,
				"static": false
			},
			{
				w: 6,
				h: 2,
				x: 6,
				y: 16,
				i: "0b6ec497-5270-479e-8873-a836b5e0e451",
				moved: false,
				"static": false
			},
			{
				w: 6,
				h: 2,
				x: 6,
				y: 14,
				i: "6a90569c-1161-4f88-a35f-a83815195318",
				moved: false,
				"static": false
			},
			{
				w: 6,
				h: 3,
				x: 0,
				y: 0,
				i: "3f9c8980-5dc5-485c-85fc-0ac0b650832f",
				moved: false,
				"static": false
			},
			{
				w: 6,
				h: 2,
				x: 0,
				y: 14,
				i: "7867906b-8927-46cf-b3ad-811f89b13c42",
				moved: false,
				"static": false
			},
			{
				w: 4,
				h: 3,
				x: 4,
				y: 9,
				i: "b53577bc-1f22-4aa0-9fb6-20fb23f321bf",
				moved: false,
				"static": false
			},
			{
				w: 4,
				h: 3,
				x: 8,
				y: 9,
				i: "39d3073a-7387-4b5a-847d-657540025daa",
				moved: false,
				"static": false
			},
			{
				w: 3,
				h: 2,
				x: 0,
				y: 12,
				i: "5ed8ee84-229f-488d-8742-5a555396354f",
				moved: false,
				"static": false
			},
			{
				w: 9,
				h: 2,
				x: 3,
				y: 12,
				i: "0d062bfd-7cc9-4021-a2d2-cfe9a81f8bf1",
				moved: false,
				"static": false
			},
			{
				w: 9,
				h: 3,
				x: 3,
				y: 3,
				i: "f6ad2d37-9f9e-4c8d-8d3a-1be55c951e06",
				moved: false,
				"static": false
			},
			{
				w: 3,
				h: 3,
				x: 0,
				y: 3,
				i: "91fd7c54-0b38-4f1e-b8c7-92ae0dcd8406",
				moved: false,
				"static": false
			},
			{
				w: 3,
				h: 3,
				x: 0,
				y: 6,
				i: "376685a3-d45a-4fb4-a5a3-57b78ad9e83f",
				moved: false,
				"static": false
			},
			{
				w: 9,
				h: 3,
				x: 3,
				y: 6,
				i: "35e36b5d-5b71-4381-bcaa-137e2813f338",
				moved: false,
				"static": false
			}
		],
		xl: [
		],
		md: [
		]
	};
	var vulnReportingBoard = {
		widgets: widgets,
		layouts: layouts
	};

	const InsightsDashboards = {
	  "AWS Accounts": awsAccountBoard,
	  "AWS IAM": awsIamBoard,
	  "AWS Resources": awsResourcesBoard,
	  "AWS S3 Security": awsS3Security,
	  "Software Dependencies and Licenses": codeDepsBoard,
	  "Data Breach Cost": dataBreachCostBoard,
	  "Data Protection": dataProtectionBoard,
	  "Secure Development": developmentBoard,
	  "Firewall Rules Matrix": firewallBoard,
	  "GDPR Data Locations": gdprDataLocationsBoard,
	  "High Risk Assets": highRiskAssetsBoard,
	  "Resource Classification": resourceClassificationBoard,
	  "Risk Register": riskRegisterBoard,
	  "Team Growth": teamGrowthBoard,
	  "User Access": userAccessBoard,
	  "User Endpoints": userEndpointsBoard,
	  "User Training": userTrainingBoard,
	  "Vendor Management": vendorMgmtBoard,
	  "Vulnerability Reporting": vulnReportingBoard,
	};

	return InsightsDashboards;

})));
